import * as d3 from 'd3';

import { ITitle } from './ITitle';

export class Title implements ITitle {

    private _group: d3.Selection<any>;
    private _height: number;
    private _isVisible: boolean;
    private _text: string;
    private _translateX: number;
    private _translateY: number;
    private _width: number;

    constructor(container: d3.Selection<any> | d3.selection.Enter<any>) {
        this._height = 25;
        this._isVisible = true;
        this._text = 'Title';
        this._width = 200;
        this.init(container);
    }

    private init(container: d3.Selection<any> | d3.selection.Enter<any>) {
        this._group = container
            .append('g')
            .classed('title-group', true);

        this._group.append('text')
            .classed('title-text', true).attr({
                'x': 0,
                'y': (this.height() / 2 - 2) * (this.ratio() || 1),
                'text-anchor': 'middle',
                'dy': '0.35em'
            })
            .text(this.text());
    }

    translate(translateX: number, translateY: number): void {
        const ratio = this._ratio || 1;
        this._translateX = isNaN(translateX) ? 0 : translateX;
        this._translateY = isNaN(translateY) ? 0 : translateY;
        this._group
            .transition()
            .attr({
                'transform': `translate(${this._translateX},${this._translateY + 10 * ratio})`
            });
    }

    isVisible(value?: boolean): boolean {
        if (value !== null && value !== undefined) {
            this._isVisible = value;
            this._group.classed('hidden-group', !this._isVisible);
        }
        return this._isVisible;
    }

    width(value?: number): number {
        if (value !== null && value !== undefined) {
            this._width = value;
        }
        return this._width;
    }

    height(value?: number): number {
        if (value !== null && value !== undefined) {
            this._height = value;
        }
        return this._height;
    }

    text(value?: string): string {
        if (value !== null && value !== undefined) {
            this._text = value;
            this._group.selectAll('text')
                .attr('y', (this.height() / 2 - 2) * (this._ratio || 1))
                .text(value);
        }
        return this._text;
    }

    resize(chartWidth?: number, chartHeight?: number) {
        this.translate(chartWidth / 2, this._translateY);
    }

    private _ratio: number = 1;
    ratio(): number;
    ratio(value: number): this;
    ratio(value?: number) {
        if (arguments.length) {
            this._ratio = value;
            this._group.selectAll('text')
                .attr('y', (this.height() / 2 - 2) * (value || 1));
            return this;
        }
        return this._ratio;
    }
}
